import { gql } from '@apollo/client';

export const EXECUTE_IMAGE_PROMPT = gql`
  query ExecuteImagePrompt($prompt: NonEmptyTrimmedString!) {
    executeImagePrompt(prompt: $prompt) {
      b64Json
    }
  }
`;
